import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Navbar({ changeToogle }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  
  const client = localStorage.getItem("client");
  const name = localStorage.getItem("name");
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  

  const handleLogout = () => {
     // Limpiar localStorage
    //localStorage.clear();
    localStorage.setItem("isLogin", false);
    localStorage.setItem("token", "NOK");
    window.location.href = '/login';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Obtener iniciales para el avatar
  const getInitials = () => {
    if (!name) return "U";
    return name
      .split(" ")
      .map(word => word[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark shadow-sm" style={{ backgroundColor: "#3F51B5" }}>
      <div className="container-fluid">
        <div className="d-flex align-items-center">
          <button 
            className="btn btn-link text-white p-0 me-3"
            onClick={(e) => changeToogle()}
          >
            <i className="bi bi-list fs-4"></i>
          </button>
        </div>


        <div className="text-white">          
          <i className="bi bi-database"></i>
          <span className="text-truncate"> {client} - </span>          
          <span className="text-truncate">{name}</span>          
        </div>
        
        <div className="d-flex align-items-center" ref={menuRef}>
          {/* Versión móvil del nombre */}
          <span className="text-white me-2 d-lg-none">
            <strong>{name || "Usuario"}</strong>
          </span>
          
          {/* Dropdown personalizado */}
          <div className="position-relative">
            <button
              className="btn btn-link text-white p-0 d-flex align-items-center"
              onClick={() => setIsOpen(!isOpen)}
              style={{ textDecoration: 'none' }}
            >
              <div 
                className="rounded-circle bg-white text-primary d-flex align-items-center justify-content-center"
                style={{ width: '38px', height: '38px', fontSize: '16px', fontWeight: 'bold' }}
              >
                {getInitials()}
              </div>
              <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} ms-1 d-none d-lg-inline`}></i>
            </button>

            {/* Menú desplegable */}
            {isOpen && (
              <div 
                className="position-absolute end-0 mt-2 bg-white rounded-3 shadow-lg"
                style={{ 
                  minWidth: '280px',
                  zIndex: 1000,
                  animation: 'fadeIn 0.2s ease-in-out'
                }}
              >
                {/* Header del perfil */}
                <div className="p-3 border-bottom">
                  <div className="d-flex align-items-center">
                    <div 
                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3"
                      style={{ width: '48px', height: '48px', fontSize: '18px', fontWeight: 'bold' }}
                    >
                      {getInitials()}
                    </div>
                    <div>
                      <h6 className="mb-0 fw-bold">{name}</h6>
                      {client && <small className="text-muted d-block">Cliente: {client}</small>}
                      {username && <small className="text-muted d-block">Usuario: {username}</small>}
                      {role && <small className="text-muted d-block">Rol: {role}</small>}
                    </div>
                  </div>
                </div>

                {/* Opciones del menú */}
                <div className="py-2">
                  <button className="dropdown-item py-2 px-3" onClick={() => {/* navegar a perfil */}}>
                    <i className="bi bi-person me-2"></i>
                    Mi Perfil
                  </button>
                  <button className="dropdown-item py-2 px-3" onClick={() => {/* navegar a configuración */}}>
                    <i className="bi bi-gear me-2"></i>
                    Configuración
                  </button>
                  
                  <hr className="my-2" />
                  
                  <button 
                    className="dropdown-item py-2 px-3 text-danger"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Cerrar Sesión
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .dropdown-item {
          transition: background-color 0.2s;
        }
        
        .dropdown-item:hover {
          background-color: #f8f9fa;
        }
        
        .dropdown-item.text-danger:hover {
          background-color: #fff5f5;
        }
      `}</style>
    </nav>
  );
}

export default Navbar;